export type ThemeMode = 'light' | 'dark';

export interface Theme {
  background: {
    primary: string;
    secondary: string;
    tertiary: string;
  };
  text: {
    primary: string;
    secondary: string;
    tertiary: string;
    inverse?: string;
  };
  border: {
    primary: string;
    secondary: string;
  };
  accent: {
    primary: string;
    secondary: string;
    tertiary: string;
    gradient: string;
  };
}

export const lightTheme: Theme = {
  background: {
    primary: 'bg-white',
    secondary: 'bg-gray-50',
    tertiary: 'bg-gray-100',
  },
  text: {
    primary: 'text-gray-900',
    secondary: 'text-gray-600',
    tertiary: 'text-gray-400',
    inverse: 'text-white',
  },
  border: {
    primary: 'border-gray-200',
    secondary: 'border-gray-300',
  },
  accent: {
    primary: 'bg-indigo-600',
    secondary: 'bg-blue-500',
    tertiary: 'bg-indigo-100',
    gradient: 'bg-gradient-to-r from-indigo-600 to-blue-500',
  },
};

export const darkTheme: Theme = {
  background: {
    primary: 'bg-gray-900',
    secondary: 'bg-gray-800',
    tertiary: 'bg-gray-700',
  },
  text: {
    primary: 'text-gray-100',
    secondary: 'text-gray-300',
    tertiary: 'text-gray-500',
    inverse: 'text-gray-900',
  },
  border: {
    primary: 'border-gray-700',
    secondary: 'border-gray-600',
  },
  accent: {
    primary: 'bg-indigo-500',
    secondary: 'bg-blue-400',
    tertiary: 'bg-indigo-900',
    gradient: 'bg-gradient-to-r from-indigo-500 to-blue-400',
  },
};

export const themes: Record<ThemeMode, Theme> = {
  light: lightTheme,
  dark: darkTheme,
};
